import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const Headed2LogoIcon = ({ label = 'Headed2Logo', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M121.9 150a31.7 31.7 0 1 1-31.6-31.7 31.6 31.6 0 0 1 31.6 31.7" style="fill:#54ad66"/><path d="M130.6 273.2a26.1 26.1 0 0 1-19.6-43.1l69.9-80.1L111 69.9a26 26 0 0 1 39.2-34.2l84.8 97.2a26.1 26.1 0 0 1 0 34.2l-84.8 97.2a26.3 26.3 0 0 1-19.6 8.9" style="fill:#54ad66"/></svg>`}
    />
  )
}

Headed2LogoIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { Headed2LogoIcon }
